import React from "react";
import { Divider, Grid, Table, TableBody, TableContainer, TableHead } from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../../Components/MaterialTableStyle/MaterialTableStyle";
const ApplicationHistoryTable = ({ ApplicationHistoryData }) => {
  return (
    <Grid container item lg={12} sm={12} md={12} xs={12} bgcolor={"#FFFFFF"} borderRadius={"6px"} flexDirection={"column"} alignItems={"flex-start"} className="my-3 p-3">
      <h4 className="poppinsSemiBold Text-Prime-Black text-center">
        Application History
      </h4>
      <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
      <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
        <TableContainer className="mt-3">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>Application ID</StyledTableCell>
                <StyledTableCell>Post Name</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            {ApplicationHistoryData.length > 0 ? (
              <TableBody>
                {ApplicationHistoryData.map((row, i) => (
                  <StyledTableRow key={i}>
                    <StyledTableCell align="left">
                      <p  className="poppinsRegular TextUnderGreen pointer">{row?.application_id}</p>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <p className="text-black poppinsRegular">{row?.postname}</p>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <StyledTableCell colSpan={2} align="center">
                  <Grid item container lg={12} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                    <h5 className="text-black poppinsMedium mb-3">No Application History Available</h5>
                  </Grid>
                </StyledTableCell>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default ApplicationHistoryTable;
